
















































































































































































































































































































import '@/compiled-icons/funnel';
import '@/compiled-icons/funnel-outline';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasPaginationTemplate from '../AmetrasPaginationTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import AmetrasAdvancedFilterTemplate from '@/views/AmetrasAdvancedFilterTemplate.vue';

import {
  DataProviderDataResponse,
  DATATABLE_SERVICE_INSTANCE,
  TableAccessConfig
} from '@/services/datatable/datatable.service';
import DataTableTemplate from '@/views/datatable/DataTableTemplate.vue';
import {cloneDeep, isEqual} from 'lodash';
import {DOCUMENT_SCROLL_SERVICE_INSTANCE} from '@/services/documentscroll.service';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import DatatableListFilterTemplate from '@/views/datatable/DatatableListFilterTemplate.vue';
import {ICONS_SERVICE_INSTANCE} from '@/utils/icons.service';
import '@/compiled-icons/more-horiz';
import {
  CustomDTIconUrlRowDto,
  CustomDTTemplateDto,
  ExtendedFilterPreset,
  MouseOverMenuConfig
} from '@/views/datatable/datatable';
import {AMETRAS_PARAM_UTILS} from '@/utils/params.utils';
import AmetrasDynamicContent from '@/views/AmetrasDynamicContent.vue';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';
import {COLOR_SERVICE_INSTANCE} from '@/services/style/color.service';
import {FONT_SERVICE_INSTANCE} from '@/services/style/font.service';


export interface MouseOverDetailsConfig {
  x: number;
  y: number;
  minWidthInPx: number;
  maxWidthInPx: number;
  row?: DisguiseDto.DTRowDto;
}

@Component({
  components: {
    DataTableTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasAdvancedFilterTemplate,
    AmetrasTextFieldTemplate,
    DatatableListFilterTemplate,
    AmetrasPaginationTemplate,
    AmetrasDynamicContent,
  }
})

export default class DataTableListTemplate extends Vue {

  @Prop({
    type: Object as () => DisguiseDto.TimelineDatatableListPanelContentDto,
    required: true
  }) panel!: DisguiseDto.TimelineDatatableListPanelContentDto;
  input: Partial<CustomDTTemplateDto> = {
    search: {
      fullTextSearch: {
        active: false
      },
      columnBasedSearch: {}
    }
  };

  loading: boolean = false;
  maxSize: number = 0; // search provider controlled maxSize for a page
  totalPages: number = 0; // count of available pages for this search query
  page: number = 0; // search provider controlled page for this search query. Will be reset if page is out of range.
  originalDocumentScrollXOffset: number = 0;

  inputConfigurationSubscriptionActive = false; // watch for changes of inputConfiguration active
  inputConfiguration: DisguiseDto.DTInputConfigurationDto = {}; // contains the FULL search query

  tableAccessConfig: TableAccessConfig | undefined; // holds the current search provider.
  tempInputConfiguration: DisguiseDto.DTInputConfigurationDto | null = null;
  iconsService = ICONS_SERVICE_INSTANCE;
  colorService = COLOR_SERVICE_INSTANCE;
  fontService = FONT_SERVICE_INSTANCE;


  showMouseOverDetailsConfig: boolean = false;
  mouseOverDetailsConfig: MouseOverDetailsConfig | null = null;

  showRowMouseOverMenu: boolean = false;
  mouseOverMenuConfig: MouseOverMenuConfig | null = null;

  fieldResolver = DYNAMIC_FIELD_RESOLVER_INSTANCE;

  @Watch('inputConfiguration', {deep: true}) onInputConfigurationChanged() {
    if (this.inputConfigurationSubscriptionActive) {
      this.loadData();
    }
  }

  rowMouseOverAction(event: MouseEvent,
                     el: HTMLElement,
                     action: CustomDTIconUrlRowDto) {
    let flyoutConfiguration: DisguiseDto.DTFlyoutActionConfiguration | undefined;
    if (action.actionConfiguration && action.actionConfiguration['@type'] === 'DTFlyoutActionConfiguration') {
      flyoutConfiguration = action.actionConfiguration;
    } else if (action.hoverActionConfiguration && action.hoverActionConfiguration['@type'] === 'DTFlyoutActionConfiguration') {
      flyoutConfiguration = action.hoverActionConfiguration;
    }

    if (flyoutConfiguration && flyoutConfiguration.content !== undefined) {
      this.mouseOverMenuConfig = {
        x: event.clientX + 15,
        y: event.clientY + 15,
        maxWidthInPx: flyoutConfiguration.maxWidthInPx || 1000,
        minWidthInPx: flyoutConfiguration.minWidthInPx || 200,
        title: flyoutConfiguration.flyoutTitle,
        content: flyoutConfiguration.content,
        primaryKey: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
        onClose: () => undefined,
        onSave: () => undefined,
      };
      this.showRowMouseOverMenu = true;
    }
  }

  rowMouseLeaveAction(event: MouseEvent,
                      el: HTMLElement,
                      action: CustomDTIconUrlRowDto) {
    if (action.actionConfiguration) {
      this.showRowMouseOverMenu = false;
      this.mouseOverMenuConfig = null;
    }
  }

  mouseLeaveAction() {
    this.showMouseOverDetailsConfig = false;
    this.mouseOverDetailsConfig = null;
  }

  mouseOverAction(event: MouseEvent,
                  row: DisguiseDto.DTRowDto) {
    this.mouseOverDetailsConfig = {
      x: event.clientX + 15,
      y: event.clientY + 15,
      maxWidthInPx: 1000,
      minWidthInPx: 300,
      row
    };
    this.showMouseOverDetailsConfig = true;
  }

  applyTempFilterSettings(panelContent: DisguiseDto.TimelineDatatableListPanelContentDto,
                          newInputConfiguration: DisguiseDto.DTInputConfigurationDto) {
    if (newInputConfiguration) {
      this.inputConfiguration = newInputConfiguration;
    }
    panelContent.showFilter = false;
    this.closeDialog();
  }

  mounted() {
    this.inputConfiguration = {
      page: 0,
      size: 10,
      selectMode: false,
      filterColumns: []
    };
    this.loadData();
  }

  dragStart(event: DragEvent, columns: DisguiseDto.DTColumnsDto[], cells: DisguiseDto.DTCellDto[]) {
    const keyValuePairs: { [fieldName: string]: string } = {};

    for (let columnIndex = 0; columnIndex < columns.length; columnIndex++) {
      const currentColumn = columns[columnIndex];
      if (currentColumn.key && this.input.keys && this.input.keys.indexOf(currentColumn.key) >= 0 && cells[columnIndex].value !== undefined) {
        keyValuePairs[currentColumn.key] = cells[columnIndex].value || '';
      }
    }

    event.dataTransfer?.setData('text', JSON.stringify({...keyValuePairs, content: ' '}));
  }


  onColumnConfigurationChange(newInputConfiguration: DisguiseDto.DTInputColumnDto[]) {
    this.inputConfiguration = {
      ...this.inputConfiguration,
      columns: newInputConfiguration,
      page: 0,
      userPreferredCustomFilterConfig: undefined
    };
  }

  loadData() {
    this.loading = true;

    if (!this.tableAccessConfig) {
      DATATABLE_SERVICE_INSTANCE.getTableConfig(
          this.panel.templateUrl || '',
          this.inputConfiguration
      ).then((tableConfig) => {
        this.tableAccessConfig = tableConfig;
        this.loadInitialDataFromSearchProvider();
      }, (error) => {
        if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
          this.$store.commit('showSnack', {
            message: 'Datenabruf fehlgeschlagen.',
            color: 'error'
          });
        }
        this.loading = false;
      });
    } else {
      this.loadDataFromSearchProvider();
    }
  }

  loadInitialDataFromSearchProvider() {
    const response = this.tableAccessConfig?.searchProvider.getInitialData(this.inputConfiguration);
    if (response) {
      this.handleSearchProviderResponse(response);
    }
  }

  loadDataFromSearchProvider() {
    this.tableAccessConfig?.searchProvider.getData(this.inputConfiguration).then((response) => {
      this.handleSearchProviderResponse(response);
      this.loading = false;
    }, (error) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: 'Datenabruf fehlgeschlagen.',
          color: 'error'
        });
      }
      this.loading = false;
    });
  }

  /**
   * Update the local values after search provider returned data
   */
  handleSearchProviderResponse(response: DataProviderDataResponse) {
    this.input = {
      ...response.data,
      filterPresets: ((
          filterPresets: DisguiseDto.DTFilterPresetDto[],
          columns: DisguiseDto.DTColumnsDto[]
      ) => {
        const result: ExtendedFilterPreset[] = [];

        const inputConfigurationIndexedByKey: { [key: string]: DisguiseDto.DTColumnSearchDto | undefined } = {};
        for (const currentInputConfigurationColumn of columns || []) {
          if (currentInputConfigurationColumn.key) {
            inputConfigurationIndexedByKey[currentInputConfigurationColumn.key] = currentInputConfigurationColumn.search;
          }
        }

        for (const currentFilterPreset of filterPresets) {
          let filterPresetActive = true;

          for (const currentFilterConfig of currentFilterPreset.filter || []) {
            const columnSpecFound = inputConfigurationIndexedByKey[currentFilterConfig.key || ''];
            if (!columnSpecFound) {
              throw new Error(`Unknown Column key: ${currentFilterConfig.key}`);
            }
            if (currentFilterConfig.searchValue && currentFilterConfig.searchValue !== columnSpecFound.currentValue) {
              filterPresetActive = false;
              break;
            } else if (currentFilterConfig.searchValues && !isEqual(currentFilterConfig.searchValues, columnSpecFound.searchValues)) {
              filterPresetActive = false;
              break;
            }
          }

          result.push({
            ...currentFilterPreset,
            active: filterPresetActive
          });
        }

        return result;
      })(response.data.filterPresets || [], response.data.columns || [])
    };
    this.maxSize = response.maxSize;
    this.totalPages = response.totalPages;
    this.page = response.page;
    if (!this.inputConfigurationSubscriptionActive) {
      this.inputConfiguration = {
        page: response.page,
        selectMode: false,
        size: response.size,
        filterColumns: this.inputConfiguration.filterColumns,
        columns: (() => {
          const result: DisguiseDto.DTInputColumnDto[] = [];
          if (this.input.columns) {
            for (let columnIndex = 0; columnIndex < this.input.columns.length; columnIndex++) {
              const column = this.input.columns[columnIndex];
              result[columnIndex] = {
                index: columnIndex,
                key: column.key,
                searchValue: (column.search || {}).currentValue,
                sort: column.sort,
                sortRank: undefined
              };
            }
          }
          return result;
        })(),
        searchValue: this.input.search?.fullTextSearch?.currentValue
      };
      Vue.nextTick(() => {
        this.inputConfigurationSubscriptionActive = true;
      });
    } else {
      this.inputConfigurationSubscriptionActive = false;
      this.inputConfiguration.page = response.page;
      Vue.nextTick(() => {
        this.inputConfigurationSubscriptionActive = true;
      });
    }

    this.loading = false;
  }

  findSelectionText(selectValues: DisguiseDto.SelectDto[], value?: string) {
    for (const currentSelectValue of selectValues) {
      if (isEqual(currentSelectValue.ids, value)
          || isEqual(currentSelectValue.value, value)) {
        return currentSelectValue.text;
      }
    }
  }

  getBackgroundStyleFromPriorityList(backgroundColorPriority: DisguiseDto.EnumColor[]) {
    let result = '';
    for (const currentBackgroundColorEntry of backgroundColorPriority || []) {
      if (currentBackgroundColorEntry) {
        result = this.colorService.getColor(
            currentBackgroundColorEntry,
            'BACKGROUND',
            this.$vuetify.theme.dark,
            true
        );
        break;
      }
    }
    return result;
  }

  getFontStyleFromPriorityList(fontWeightPriority: DisguiseDto.EnumFontWeight[]) {
    let result = '';
    for (const currentFontWeightEntry of fontWeightPriority || []) {
      if (currentFontWeightEntry) {
        result = this.fontService.getFontWeight(currentFontWeightEntry);
        break;
      }
    }
    return result;
  }

  openDialog() {
    this.originalDocumentScrollXOffset =
        DOCUMENT_SCROLL_SERVICE_INSTANCE.readCurrentDocumentScrollXPosition();
    DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(0);
    this.panel.showFilter = true;
  }

  closeDialog() {
    this.panel.showFilter = false;
    DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(this.originalDocumentScrollXOffset);
    this.loadData();
  }

  activateFilterPreset(filterPreset: ExtendedFilterPreset) {
    if (filterPreset.filter) {
      const inputConfigurationIndexedByKey: { [key: string]: DisguiseDto.DTInputColumnDto } = {};
      for (const currentInputConfigurationColumn of cloneDeep(this.inputConfiguration.columns || [])) {
        if (currentInputConfigurationColumn.key) {
          inputConfigurationIndexedByKey[currentInputConfigurationColumn.key] = currentInputConfigurationColumn;
        }
      }

      for (const currentFilterPreset of this.input.filterPresets || []) {
        if (currentFilterPreset !== filterPreset) {
          currentFilterPreset.active = false;
        }
      }

      if (!filterPreset.active) {
        filterPreset.active = true;
        for (const currentFilter of filterPreset.filter) {
          const columnSpecFound = inputConfigurationIndexedByKey[currentFilter.key || ''];
          if (!columnSpecFound) {
            throw new Error(`Unknown Column key: ${currentFilter.key}`);
          }
          if (currentFilter.searchValue) {
            columnSpecFound.searchValue = currentFilter.searchValue;
          } else {
            delete columnSpecFound.searchValue;
          }
          if (currentFilter.searchValues) {
            columnSpecFound.searchValues = currentFilter.searchValues;
          } else {
            delete columnSpecFound.searchValues;
          }
        }
      } else {
        filterPreset.active = false;
        for (const currentFilter of filterPreset.filter) {
          const columnSpecFound = inputConfigurationIndexedByKey[currentFilter.key || ''];
          if (!columnSpecFound) {
            throw new Error(`Unknown Column key: ${currentFilter.key}`);
          }
          if (currentFilter.searchValue) {
            delete columnSpecFound.searchValue;
          } else if (currentFilter.searchValues) {
            delete columnSpecFound.searchValues;
          }
        }
      }

      this.inputConfiguration = {
        ...this.inputConfiguration,
        columns: Object.values(inputConfigurationIndexedByKey)
      };
    }
  }

  private getCustomIconStyle(rowIcon: DisguiseDto.DTIconUrlRowDto, props: {
    isExpanded: boolean
  }) {
    let result: { [key: string]: string | string[] } = {};
    const isIconWithExpandConfiguration = rowIcon.actionConfiguration
        && rowIcon.actionConfiguration['@type'] === 'DTExpandSectionActionConfiguration';
    if (isIconWithExpandConfiguration && props.isExpanded) {
      // we found an icon with the expand action configuration. we will rotate the icon if the row is expanded
      result = {
        ...result,
        transform: 'rotate(180deg)'
      };
    }
    return result;
  }

}
